import React from "react";
import Modal from "../../../component/ui/modal";
import { Calendar, Bell, Eye } from "lucide-react";
import { Badge } from "../../../component/ui/Badge";
import { real_date } from "../../../services/convert/date";
import { INotification } from "../../../store/types/notification";

type IViewNotification = {
  isOpen: boolean;
  isClose: () => void;
  notification: INotification | null;
};

const ViewNotification = ({
  isOpen,
  isClose,
  notification,
}: IViewNotification) => {
  if (!notification) return null;

  const isRead = notification.seen === "1";
  const formattedDate = real_date(notification.created_at);
  return (
    <Modal
      title={
        <div className="flex items-center gap-2">
          <Bell className="h-5 w-5 text-primary-500 mr-1" />
          Notification
        </div>
      }
      open={isOpen}
      onClose={isClose}
      onOkClick={isClose}
      hasButton={false}
    >
      <div className="space-y-4">
        {/* Subject/Title */}
        <div>
          <h3 className="text-lg font-semibold text-gray-800">
            {notification.subject}
          </h3>
        </div>

        {/* Status badges */}
        <div className="flex items-center gap-2 flex-wrap">
          <Badge variant={isRead ? "secondary" : "black"}>
            <Eye className="mr-1 h-3 w-3" />
            {isRead ? "Read" : "Unread"}
          </Badge>
          {/* Timestamp */}
          <Badge variant="outline">
            <Calendar />
            {formattedDate}
          </Badge>
        </div>

        {/* Message content */}
        {notification.text && (
          <div
            className="prose prose-sm dark:prose-invert max-w-none text-foreground mt-4"
            dangerouslySetInnerHTML={{ __html: notification.text }}
          />
        )}
      </div>
    </Modal>
  );
};

export default ViewNotification;
